import * as yup from 'yup'

export const company = yup.object().shape({
  empresaId: yup.string().required('La empresa es obligatorio'),
})
